// Engelse teksten van de herinneringen in de webapp (zie remindersApp.nl.ts).
export const appRemindersEn = {
    section: 'Reminders',
    sectionHint: 'An extra nudge on the tablet: the screen calls your child by name, with a big picture. With a tick list of what needs to come along.',
    allDayHint: 'Reminders work for events with a time.',
    add: 'Reminder',
    addTitle: 'New reminder',
    editTitle: 'Edit reminder',
    edit: 'Edit',
    remove: 'Remove',
    removed: 'Reminder removed',
    confirmAdd: 'Add reminder',
    confirmSave: 'Update reminder',
    closeForm: 'Close the form without this reminder',
    max: 'At most 5 reminders per event.',
    when: 'When',
    customWhen: 'Custom time',
    customLabel: 'Minutes before',
    customHint: '1 to 1440 minutes (one day).',
    offsetInvalid: 'Choose 1 to 1440 minutes.',
    text: 'Text',
    textPlaceholder: 'Get ready for practice',
    textRequired: 'Enter a short text.',
    textTooLong: 'At most 60 characters.',
    suggestions: 'Suggestions',
    picto: 'Pictogram',
    forWho: 'For whom',
    everyone: 'Everyone in the event',
    everyoneKids: 'All children',
    whoRequired: 'Choose who this reminder is for.',
    prunedChanged: '{names} is no longer in the event; reminder "{title}" was updated.',
    prunedChangedMany: '{names} are no longer in the event; reminder "{title}" was updated.',
    prunedRemoved: '{names} is no longer in the event; reminder "{title}" was removed.',
    prunedRemovedMany: '{names} are no longer in the event; reminder "{title}" was removed.',
    prunedThisHint: 'If you choose "Only this one" when saving, the reminders for the other times stay as they are.',
    allDayDrop: 'All-day events do not call on the tablet: these reminders go when you save.',
    and: 'and',
    speak: 'Read aloud',
    speakHint: 'The tablet says the name and the text out loud.',
    sound: 'Sound',
    soundHint: 'A soft chime (not during quiet hours).',
    preview: 'How the tablet calls',
    previewOk: 'OK',
    previewContext: '{title} at {time}',
    previewNoTitle: 'Event',
    minutes: '{count} min',
    hours: '{count} h',
    hoursMinutes: '{hours} h {minutes} min',
    before: '{when} before',
    chip: '{when} before · {title}',
    chipLabel: 'Reminder {when} before: {title}',
    skipOnce: 'Not this time',
    skipOnceLabel: 'Skip reminder "{title}" this time only',
    skipOnceDone: 'The tablet will not call this time: {title}',
    skippedChip: 'Not this time',
    unskip: 'Call after all',
    unskipLabel: 'Call reminder "{title}" this time after all',
    unskipDone: 'The tablet will call again this time: {title}',
    suggestTraining: 'Get ready for practice',
    suggestSwim: 'Pack the swim bag',
    suggestBag: 'Get your bag ready',
    suggestShoes: 'Shoes and coat on',
    suggestGeneric: 'Get ready for {title}',
    suggestGenericEmpty: 'Get ready',
    taskTime: 'Time',
    taskTimeHint: 'Can stay empty.',
    taskAnnounce: 'Announce on the board',
    taskAnnounceHint: 'At that time the tablet chimes and says who should do what. Silent during quiet hours and at night.',
};
//# sourceMappingURL=remindersApp.en.js.map